import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import measurementConfig from './config/measurement';
import { initializeConsent } from './utils/analytics';

// Consent Mode komutları, ilk page_view veya GTM yüklemesinden önce sıraya girer.
if (measurementConfig.enabled) {
  initializeConsent();
}

// Eski deploy'un HTML'i cache'lenmis kullanıcılarda chunk hash'leri bayatlar ve
// ChunkLoadError ile React mount olamaz (stilsiz prerender icerik gorunur).
// Bu durumda sayfayi bir kez reload edip guncel HTML+chunk'lari almasini saglariz.
window.addEventListener('error', (event) => {
  const assetUrl = event.target && (event.target.src || event.target.href);
  let isFirstPartyChunkAsset = false;

  if (assetUrl) {
    try {
      const parsedUrl = new URL(assetUrl, window.location.href);
      isFirstPartyChunkAsset = parsedUrl.origin === window.location.origin
        && /^\/static\/(?:js|css)\//.test(parsedUrl.pathname);
    } catch {
      isFirstPartyChunkAsset = false;
    }
  }

  const isChunkLoadError = /ChunkLoadError|Loading chunk/i.test(event.message || '');
  if ((isFirstPartyChunkAsset || isChunkLoadError) && !sessionStorage.getItem('chunkRetry')) {
    sessionStorage.setItem('chunkRetry', '1');
    window.location.reload();
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
